<template>
  <div>
    <el-aside style="width: 215px; overflow: hidden; float: left">
      <ul v-show="!form.dsPId" class="left_url_tab">
        <div class="menu">
          <div class="title">产品分类</div>
          <el-tree
            ref="tree"
            node-key="typeId"
            style="margin: 0px 0 0 0; padding: 4px 0 8px 0"
            :data="typeIdTree"
            :props="defaultProps"
            @node-click="handleNodeClick"
            :default-expanded-keys="expandedKeys"
            :highlight-current="true"
          ></el-tree>
        </div>
      </ul>
      <ul
        v-show="
          form.productType == '02' &&
            form.remark == '1' &&
            labelAttrList.length > 0
        "
        class="left_url_tab"
        style="margin-top: 16px"
      >
        <div class="menu">
          <div class="title">产品主题</div>
          <el-tree
            ref="labelTree"
            node-key="value"
            style="margin: 0px 0 0 0; padding: 4px 0 8px 0"
            :data="labelAttrList"
            show-checkbox
            @check-change="handleCheckChange"
          ></el-tree>
        </div>
      </ul>
      <Broadcast style="margin-top: 19px"></Broadcast>
    </el-aside>
    <div id="custom-online">
      <Breadcrumb></Breadcrumb>
      <div class="form-body">
        <div>
          <div class="form-label">产品等级</div>
          <el-radio-group
            @change="loadData"
            v-model="form.vipType"
            class="hide_input"
          >
            <el-radio label="">全部</el-radio>
            <el-radio
              :label="value.value"
              :key="value.value"
              v-for="value in dictData['vipType']"
              >{{ value.label }}</el-radio
            >
          </el-radio-group>
        </div>

        <div>
          <div class="form-label">生产时长</div>
          <el-radio-group
            @change="loadData"
            v-model="form.prodDays"
            class="hide_input"
          >
            <el-radio label="">全部</el-radio>
            <el-radio
              :label="value.value"
              :key="value.value"
              v-for="value in dictData['prod_days']"
              >{{ value.label }}</el-radio
            >
          </el-radio-group>
        </div>
        <div>
          <div class="form-label">采购价格</div>
          <el-radio-group
            v-model="form.priceValue"
            class="hide_input"
            @change="loadData"
          >
            <el-radio label="">全部</el-radio>
            <el-radio v-for="item in priceList" :label="item.id">{{
              item.name
            }}</el-radio>
          </el-radio-group>
        </div>
        <div>
          <div class="form-label">产品重量</div>
          <el-radio-group
            v-model="form.weightValue"
            class="hide_input"
            @change="loadData"
          >
            <el-radio label="">全部</el-radio>
            <el-radio v-for="item in weightList" :label="item.id">{{
              item.name
            }}</el-radio>
          </el-radio-group>
        </div>
        <div>
          <div class="form-label">适合性別</div>
          <el-radio-group
            @change="loadData"
            v-model="form.sex"
            class="hide_input"
          >
            <el-radio label="">全部</el-radio>
            <el-radio
              :label="value.value"
              :key="value.value"
              v-for="value in dictData['sys_user_sex']"
              >{{ value.label }}</el-radio
            >
          </el-radio-group>
        </div>
        <div v-if="form.productType == '01'">
          <div class="form-label">产品工艺</div>
          <el-radio-group
            @change="loadData"
            v-model="form.features"
            class="hide_input"
          >
            <el-radio label="">全部</el-radio>
            <el-radio
              :label="value.value"
              :key="value.value"
              v-for="value in dictData['FEATURES']"
              >{{ value.label }}</el-radio
            >
          </el-radio-group>
        </div>
        <div style="overflow:hidden;">
          <div style="float:left;" class="form-label">所属国家</div>
          <div style="float:left;width: calc(100% - 200px);">
            <el-checkbox
              style=""
              @change="handleChangeState"
              v-model="isCheckState"
              >全选</el-checkbox
            >
            <el-checkbox-group
              clearable
              @change="loadData"
              v-model="form.state"
              placeholder="请选择国家"
              class="input"
              size="small"
              style="display: inline; margin: 0 0 0 27px"
            >
              <el-checkbox
                v-for="(value, key) in dictData['country_site']"
                :key="value.value"
                :label="value.value"
                >{{ value.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="filter">
          <div class="left">
            <el-checkbox-group
              @change="handleChangeSaleType"
              style="display: inline-block; margin: 0 36px 0 16px"
              v-model="form.saleType"
              size="small"
            >
              <el-checkbox label="1">热销</el-checkbox>
              <el-checkbox label="2">新品</el-checkbox>
            </el-checkbox-group>
            <el-input
              size="small"
              style="width: 300px; margin-right: 16px"
              placeholder="搜索产品名称/编号"
              v-model="form.proName"
              @keyup.enter.native="loadData"
            ></el-input>
            <el-input
              size="small"
              style="width: 115px; margin-right: 16px"
              placeholder="搜索生产厂商"
              v-model="form.manufacturer"
              @keyup.enter.native="loadData"
            ></el-input>
            <el-input
              size="small"
              style="width: 100px; margin-right: 16px"
              placeholder="最低价格"
              v-model="form.beginPrice"
            ></el-input>
            <el-input
              size="small"
              style="width: 100px; margin-right: 16px"
              placeholder="最高价格"
              v-model="form.endPrice"
            ></el-input>
            <el-button size="small" type="primary" @click="loadData"
              >搜索</el-button
            >
          </div>
          <div class="right order-area">
            <el-table
              class="customer-table"
              :data="rows"
              style="width: 100%"
              @sort-change="handleSortChange"
              :default-sort="{ prop: 'default', order: 'descending' }"
            >
              <el-table-column
                prop="default"
                label="默认排序"
                sortable
                width="100"
                :sort-orders="['descending']"
              >
              </el-table-column>
              <el-table-column
                prop="sales"
                label="产品销量"
                sortable
                width="100"
                :sort-orders="['descending', 'ascending']"
              >
              </el-table-column>
              <el-table-column
                prop="price"
                label="价格排序"
                sortable
                width="100"
                :sort-orders="['descending', 'ascending']"
              >
              </el-table-column>
              <el-table-column
                prop="weight"
                label="重量排序"
                sortable
                width="100"
                :sort-orders="['descending', 'ascending']"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="tab-body" style="margin-top: 0">
        <div style="overflow: hidden; margin: 4px 0">
          <el-checkbox
            v-if="form.productType == '02'"
            @change="handleCheckAllProduct"
            v-model="isCheckAll"
            style="margin: 0 16px 0 0"
            >全选</el-checkbox
          >
          <el-button
            v-if="form.productType == '02'"
            @click="handleAddBatch"
            size="small"
            type="primary"
            >批量加入我的<span v-if="form.remark == '1'">主题</span
            ><span v-else>公版</span></el-button
          >
          <pagination
            style="float: right"
            v-show="total > 0"
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="loadData"
          />
        </div>
        <div class="product-list">
          <template v-for="(item, index) in tableData">
            <div class="pro-card">
              <div class="pro-card-content-detail">
                <el-checkbox
                  v-if="form.productType == '02'"
                  style="position: absolute; left: 10px; top: 10px"
                  v-model="item.isChecked"
                  size="medium"
                ></el-checkbox>
                <div
                  @mouseover="handleMouseOver(item)"
                  @mouseout="handleMouseOut(item)"
                  @click="showDetail(item)"
                  class="card-img"
                >
                  <!-- item.thumb -->
                  <img
                    class="evenflow_scale"
                    :style="{ height: imageHeight + 'px' }"
                    :src="
                      item.mainList.length > 0
                        ? `${
                            item.mainList[item.currentProduct].picUrl
                          }?x-oss-process=image/resize,m_fill,h_500,w_500`
                        : ''
                    "
                    lazy
                  />
                </div>
                <div
                  :style="{
                    width: imageWidth + 'px',
                    top: imageWidth - 36 + 'px',
                  }"
                  :class="`sku-img-list tp-${index}`"
                >
                  <div class="img-content">
                    <ul>
                      <li
                        :class="{ 'is-select': item.currentProduct === number }"
                        @mouseover="handleSelectSku(item, number)"
                        v-for="(record, number) in item.mainList"
                        :key="number"
                        :style="{
                          backgroundColor: dictMap['color'][record.skuName],
                        }"
                      ></li>
                    </ul>
                  </div>
                </div>
                <div
                  :style="{
                    height: form.productType == '01' ? '138px' : '96px',
                  }"
                  @mouseover="handleMouseOut(item)"
                  class="card-info"
                >
                  <div class="info-div" v-show="item.showTitle">
                    <div class="detail">
                      <div :title="item.proName" class="product-title">
                        {{ item.proName }}
                      </div>
                      <div class="text" style="line-height: 28px">
                        <el-popover
                          placement="bottom-start"
                          width="322"
                          trigger="hover"
                        >
                          <div
                            class="price"
                            slot="reference"
                            style="display: inline-block; position: relative"
                          >
                            <span class="unit">￥</span>{{ item.price }}
                            <i
                              style="margin: 0 0 0 2px; font-size: 12px"
                              class="el-icon-arrow-down"
                            ></i>
                            <i
                              style="
                                margin: 0 0 0 2px;
                                font-size: 12px;
                                display: none;
                              "
                              class="el-icon-arrow-up"
                            ></i>
                          </div>
                          <div>
                            <div class="prod_drop_con">
                              <div
                                v-for="(price, index) in item.skuList[0]
                                  .priceList"
                                :key="index"
                                class="prod_drop_item"
                              >
                                <div class="prod_drop_desc">
                                  <span style="color: rgb(51, 51, 51)"
                                    >¥{{ price.price }}</span
                                  >
                                  <span
                                    >{{ price.lowNum }}-{{
                                      price.highNum
                                    }}件</span
                                  >
                                </div>
                                <div
                                  v-if="
                                    index !==
                                      item.skuList[0].priceList.length - 1
                                  "
                                  class="el-divider el-divider--vertical"
                                >
                                  <!---->
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-popover>

                        <span class="date">{{
                          dictMap["prod_days"][item.prodDays]
                        }}</span>
                      </div>
                      <div v-if="false" class="product-tag">
                        <div>
                          {{
                            dictMap["product_type"]
                              ? dictMap["product_type"][item.productType]
                              : ""
                          }}
                        </div>
                      </div>
                      <div
                        v-if="form.productType == '01'"
                        class="design-num text"
                      >
                        <div class="left">
                          大师作品：<span
                            @click="handleJumpDesign(item)"
                            class="num"
                            :style="{
                              color: item.dsNum > 0 ? 'orange' : '#aaaaaa',
                            }"
                            >{{ item.dsNum }}</span
                          >
                        </div>
                        <div class="right">
                          <a
                            :style="{
                              color: item.dsNum > 0 ? 'orange' : '#aaaaaa',
                            }"
                            @click="handleJumpDesign(item)"
                            class="design-num-link"
                            >查看</a
                          >
                        </div>
                      </div>
                      <div class="factory text" style="overflow: hidden;">
                        <div style="float:left">
                          平均发货时效：{{ item.avgDelivery }}小时
                        </div>
                        <div style="float:right;color: rgb(170, 170, 170);">
                          已售 {{ item.saleNum ? item.saleNum : 0 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="btn-div" v-show="!item.showTitle">
                    <div class="pa c153 price-gradient-box">
                      <div class="relative">
                        <div
                          class="flex-row flex-x-full weight-box"
                          style="margin-bottom: 8px"
                        >
                          <div class="w50">
                            {{ Math.round(Number(item.weight)) }}g
                          </div>
                          <div class="w50">{{ item.pdMaterial }}</div>
                        </div>
                        <div class="pl10 mt15">
                          80%平均时效：{{ item.mostDelivery }}小时
                        </div>
                        <div class="pl10 mt5">
                          平均发货时效：{{ item.avgDelivery }}小时
                        </div>
                        <div class="pl10 mt5 pb10">
                          生产商承诺发货：{{ item.agreeDelivery }}小时
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="item.remark"
                  class="product-type"
                  style="background: rgb(255, 144, 0)"
                  :style="{ left: form.productType == '02' ? '34px' : '14px' }"
                >
                  {{ item.remark }}
                </div>
                <div class="vip-type">
                  <img :src="getVipType(item.vipType)" />
                </div>
              </div>
            </div>
          </template>
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="loadData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import { mapGetters } from "vuex"
import Broadcast from "@/components/common/Broadcast"
import { addBatch } from "@/api/customProduct/design"
import { getProductList } from "@/api/customProduct/product"
import { listType } from "@/api/sysSupport/category"
import Breadcrumb from "@/components/common/Breadcrumb"
import { getProductTypeTree } from "@/api/product/type.js"
import vip0 from "@/assets/images/user/vip0.png"
import vip1 from "@/assets/images/user/vip1.png"
import vip2 from "@/assets/images/user/vip2.png"
import vip3 from "@/assets/images/user/vip3.png"
import vip4 from "@/assets/images/user/vip4.png"
import vip5 from "@/assets/images/user/vip5.png"

export default {
  name: "product",
  components: { Breadcrumb, Broadcast },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    routeName() {
      return this.$route.path
    },
  },
  data() {
    return {
      total: 6,
      form: {
        prodDays: "",
        productType: "",
        pageNum: 1,
        pageSize: 30,
        proName: "",
        dzStatus: "01",
        isAsc: "desc",
        orderByColumn: "sort",
        beginPrice: "",
        endPrice: "",
        priceValue: "",
        weightValue: "",
        vipType: "",
        saleType: [],
        sex: "",
        labelAttr: [],
        features: "",
        remark: "1",
        dsPId: "",
        state: [],
        manufacturer: ''
      },
      typeList: [],
      topName: "所有分类",
      secondTypeList: [], //
      secondName: undefined,
      tableData: [],
      categoryList: [], //分类数据
      cycleList: [], //生产周期数据
      isCheckState: true,
      productTypeList: [
        { name: "定制产品", id: "1" },
        { name: "优选产品", id: "2" },
      ],
      priceList: [
        { name: "1-10元", id: "1" },
        { name: "10-20元", id: "2" },
        { name: "20-40元", id: "3" },
        { name: "40-60元", id: "4" },
        { name: "大于60元", id: "5" },
      ], //采购价格
      weightList: [
        { name: "0-100g", id: "1" },
        { name: "100-200g", id: "2" },
        { name: "200-400g", id: "3" },
        { name: "大于400g", id: "4" },
      ], //产品重量
      imageHeight: "200",
      imageWidth: "223",

      defaultProps: {
        value: "typeId",
        label: "typeName",
        children: "childrenTree",
      },
      typeIdTree: [],
      showPrice: false,
      typeId: "",
      expandedKeys: [],
      rows: [],
      isCheckAll: false,
      vip0: vip0,
      vip1: vip1,
      vip2: vip2,
      vip3: vip3,
      vip4: vip4,
      vip5: vip5,
      isExpandLableAttr: false,
      labelAttr: "",
      isCheckLabelAttr: true,
      labelAttrList: [],
      showBroadcast: false,
    }
  },

  destroyed() {
    window.onresize = null
  },
  created() {
    let typeId = this.$route.query.typeId
    let pageNum = this.$route.query.pageNum

    let pageSize = this.$route.query.pageSize
    if (typeId) {
      this.form.typeId = typeId
      this.typeId = typeId
    }
    if (pageNum) {
      this.form.pageNum = Number(pageNum)
    }
    if (pageSize) {
      this.form.pageSize = Number(pageSize)
    }

    this.initBaseData() //获取基础数据（分类数据，生产周期数据等）
    this.loadData()
    this.getTree()
    window.setTimeout(() => {
      // let labelAttrList = []
      // let LABEL_ATTR = this.dictData["LABEL_ATTR"]
      // for (let record of LABEL_ATTR) {
      //   if (record.value.length == 4) {
      //     labelAttrList.push({
      //       label: record.label,
      //       value: record.value,
      //     })
      //   }
      // }
      // this.labelAttrList = labelAttrList

      let labelAttrList = []
      let LABEL_ATTR = this.dictData["LABEL_ATTR"]
      for (let record of LABEL_ATTR) {
        if (record.value.length == 2) {
          labelAttrList.push({
            label: record.label,
            value: record.value,
            children: [],
          })
        }
      }
      for (let record of LABEL_ATTR) {
        if (record.value.length == 4) {
          for (let item of labelAttrList) {
            if (
              item.value[0] == record.value[0] &&
              item.value[1] == record.value[1]
            ) {
              item.children.push({
                label: record.label,
                value: record.value,
              })
            }
          }
        }
      }
      this.labelAttrList = labelAttrList

      if (
        this.form.productType == "02" &&
        this.form.remark == "1" &&
        this.labelAttrList.length > 0
      ) {
        this.showBroadcast = false
      } else {
        this.showBroadcast = true
      }
    }, 1000)
  },
  mounted() {
    this.$nextTick(() => {
      window.onresize = () => {
        let cardImg = document.querySelector(".card-img")
        if (cardImg) {
          let height = cardImg.offsetWidth
          this.imageWidth = cardImg.offsetWidth
          this.imageHeight = height
        }
      }
    })
  },
  watch: {
    routeName() {
      this.form.labelAttr = []
      this.getTree()
      this.loadData()
    },
    "form.priceValue"() {
      if (this.form.priceValue == "") {
        this.form.beginPrice = ""
        this.form.endPrice = ""
      } else if (this.form.priceValue == "1") {
        this.form.beginPrice = "1"
        this.form.endPrice = "10"
      } else if (this.form.priceValue == "2") {
        this.form.beginPrice = "10"
        this.form.endPrice = "20"
      } else if (this.form.priceValue == "3") {
        this.form.beginPrice = "20"
        this.form.endPrice = "40"
      } else if (this.form.priceValue == "4") {
        this.form.beginPrice = "40"
        this.form.endPrice = "60"
      } else if (this.form.priceValue == "5") {
        this.form.beginPrice = "60"
        this.form.endPrice = ""
      }
      // this.loadData()
    },
    "form.weightValue"() {
      if (this.form.weightValue == "") {
        this.form.beginWeight = ""
        this.form.endWeight = ""
      } else if (this.form.weightValue == "1") {
        this.form.beginWeight = "0"
        this.form.endWeight = "100"
      } else if (this.form.weightValue == "2") {
        this.form.beginWeight = "100"
        this.form.endWeight = "200"
      } else if (this.form.weightValue == "3") {
        this.form.beginWeight = "200"
        this.form.endWeight = "400"
      } else if (this.form.weightValue == "4") {
        this.form.beginWeight = "40"
        this.form.endWeight = ""
      }
      // this.loadData()
    },
  },
  methods: {
    handleCheckChange(value) {
      let labelAttr = []
      let checkList = this.$refs.labelTree.getCheckedNodes()
      for (let record of checkList) {
        if (record.value.length == 4) {
          labelAttr.push(record.value)
        }
      }
      this.form.labelAttr = labelAttr
      this.loadData()
    },
    handleCommandSales(command) {
      this.form.isAsc = command
      this.form.orderByColumn = "sales"
      this.loadData()
    },
    handleChangeLabelAttrList() {
      this.loadData()
    },
    handleChangeLabelAttr() {
      let labelAttr = []
      if (this.isCheckLabelAttr) {
        this.labelAttrList.map((record) => {
          labelAttr.push(record.value)
        })
        this.form.labelAttr = labelAttr
      } else {
        this.form.labelAttr = []
      }
      this.loadData()
    },
    getVipType(vipType) {
      if (vipType == "0" || !vipType) {
        return vip0
      } else if (vipType == "1") {
        return vip1
      } else if (vipType == "2") {
        return vip2
      } else if (vipType == "3") {
        return vip3
      } else if (vipType == "4") {
        return vip4
      } else if (vipType == "5") {
        return vip5
      }
    },
    handleCheckAllProduct() {
      for (let record of this.tableData) {
        record.isChecked = this.isCheckAll
      }
    },
    handleCommandPrice(command) {
      this.form.isAsc = command
      this.form.orderByColumn = "price"
      this.loadData()
    },
    handleCommandWeight(command) {
      this.form.isAsc = command
      this.form.orderByColumn = "weight"
      this.loadData()
    },
    async getTree() {
      // this.startLoading()
      let remark = "1"
      let productType = "01"
      if (this.routeName.indexOf("select/custom/list") > -1) {
        productType = "02"
        remark = "1"
      } else if (this.routeName.indexOf("select/common/list") > -1) {
        productType = "02"
        remark = "2"
      } else {
        productType = "01"
        remark = ""
      }
      const { data } = await getProductTypeTree({
        productType,
        status: "1",
        remark: remark,
      })
      if (data) {
        data.map((record) => {
          record.typeName = `${record.typeName}(${record.proNum})`
          if (record.childrenTree) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.proNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.proNum})`
                })
              }
            })
          }
        })
        for (let i = 0; i < data.length; i++) {
          if (data[i].proNum == 0) {
            data.splice(i, 1)
            i--
          } else if (data[i].childrenTree) {
            for (let j = 0; j < data[i].childrenTree.length; j++) {
              if (data[i].childrenTree[j].proNum == 0) {
                data[i].childrenTree.splice(j, 1)
                j--
              }
            }
          }
        }

        this.typeIdTree = data
      }
      let typeId = this.$route.query.typeId
      if (typeId) {
        this.$refs.tree.setCheckedKeys([typeId])
        this.expandedKeys = [typeId]
      }
      this.$nextTick(() => {
        document.querySelector(".is-checked").className += " is-current"
      })
    },

    handleSelectSku(item, number) {
      item.currentProduct = number
    },
    initBaseData() {
      axios
        .get("https://test.onewinner.cn/api/v1/basics/basic_categories")
        .then((res) => {
          this.categoryList = res.data.data.basic_categories
          this.cycleList = res.data.data.production_cycles
        })
        .catch((err) => {})
    },
    getCpTypeList() {
      listType().then((response) => {
        this.typeList = this.handleTree(response.data, "typeId", "pTypeId")
      })
    },
    timeChange(val) {
      this.loadData()
    },
    handleChangeState() {
      this.form.state = []
      if (this.isCheckState) {
        this.dictData["amazon_site"].map((record) => {
          this.form.state.push(record.value)
        })
      }
      this.loadData()
    },
    //跳转详情页面
    showDetail(item) {
      let routeUrl = ""
      if (item.designId) {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: {
            designId: item.designId,
            showButton: 1,
            remark: this.form.remark,
            productType: this.form.productType,
          },
        })
      } else {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: {
            pId: item.pId,
            remark: this.form.remark,
            productType: this.form.productType,
          },
        })
      }

      window.open(routeUrl.href, "_blank")
    },
    handleJumpDesign(row) {
      if (row.dsNum == 0) {
        return
      }
      let routeUrl = this.$router.resolve({
        path: "/select/custom/list",
        query: {
          dsPId: row.pId,
          pageNum: 1,
          pageSize: 30,
        },
      })

      window.open(routeUrl.href, "_blank")
    },
    handleSortChange({ column, prop, order }) {
      if (order == "descending") {
        this.form.isAsc = "desc"
      } else {
        this.form.isAsc = "asc"
      }
      if (prop == "default") {
        this.form.orderByColumn = "sort"
      } else if (prop == "sales") {
        this.form.orderByColumn = "sales"
      } else if (prop == "price") {
        this.form.orderByColumn = "price"
      } else if (prop == "weight") {
        this.form.orderByColumn = "weight"
      }
      this.loadData()
    },
    loadData() {
      let form = this._.clone(this.form)

      if (this.$route.path.indexOf("select/custom/list") > -1) {
        form.productType = "02"
        form.remark = "1"
      } else if (this.$route.path.indexOf("select/common/list") > -1) {
        form.productType = "02"
        form.remark = "2"
      } else {
        form.productType = "01"
        form.remark = ""
      }
      this.form.remark = form.remark
      this.form.productType = form.productType
      form.saleType = form.saleType.join(",")
      form.labelAttr = form.labelAttr.join(",")
      form.state = form.state.join(",")
      if (form.saleType == "2,1") {
        form.saleType = "1,2"
      }
      let typeId = this.$route.query.typeId

      let dsPId = this.$route.query.dsPId

      if (dsPId) {
        form.dsPId = dsPId
        this.form.dsPId = dsPId
      } else {
        form.dsPId = ""
        this.form.dsPId = ""
      }

      this.$router.push({
        path: this.$route.path,
        query: {
          pageNum: form.pageNum,
          pageSize: form.pageSize,
          typeId,
          dsPId,
        },
      })
      this.startLoading()
      getProductList(form)
        .then((res) => {
          for (let record of res.rows) {
            record.showTitle = true
            record.isChecked = false
            record.currentProduct = 0
            for (let image of record.mainList) {
              if (image.isMain == "2") {
                for (let picture of record.mainList) {
                  if (picture.isMain == "1") {
                    picture.picUrlOther = image.picUrl
                    picture.picUrlBak = picture.picUrl
                    break
                  }
                }
                break
              }
            }
            for (let i = 0; i < record.mainList.length; i++) {
              if (record.mainList[i].isMain == "2") {
                record.mainList.splice(i, 1)
                i--
              }
            }
          }
          this.tableData = res.rows
          this.total = res.total
          this.endLoading()
          this.$nextTick(() => {
            let cardImg = document.querySelector(".card-img")
            if (cardImg) {
              let height = cardImg.offsetWidth
              this.imageWidth = cardImg.offsetWidth
              this.imageHeight = height
            }
          })
        })
        .catch(() => {
          this.endLoading()
        })
    },
    async handleAddBatch() {
      let pIdList = []
      for (let record of this.tableData) {
        if (record.isChecked) {
          pIdList.push(record.pId)
        }
      }
      if (pIdList.length == 0) {
        this.msgError("请选择产品")
        return
      }
      try {
        await addBatch({
          pId: pIdList.join(","),
        })
        for (let record of this.tableData) {
          record.isChecked = false
        }
        this.msgSuccess("批量加入成功")
      } catch (error) {}
    },
    topHandleCommand(val) {
      this.topName = val.typeName
      this.secondTypeList = val.children ? val.children : []
      if (this.secondTypeList.length > 0) {
        this.secondName = this.secondTypeList[0].typeName
        this.thirdTypeList = this.secondTypeList[0].children
          ? this.secondTypeList[0].children
          : []
      }
    },

    secondHandleCommand(val) {
      this.secondName = val.typeName
      this.thirdTypeList = val.children ? val.children : []
    },
    handleMouseOver(item) {
      if (item.mainList[item.currentProduct].picUrlOther) {
        item.mainList[item.currentProduct].picUrl =
          item.mainList[item.currentProduct].picUrlOther
      }
      item.showTitle = false
    },
    handleMouseOut(item) {
      if (item.mainList[item.currentProduct].picUrlOther) {
        item.mainList[item.currentProduct].picUrl =
          item.mainList[item.currentProduct].picUrlBak
      }
      item.currentProduct = 0
      item.showTitle = true
    },
    handleNodeClick(data) {
      this.$refs.tree.setCheckedKeys([])
      this.form.typeId = data.typeId
      this.form.pageNum = "1"
      this.loadData()
    },
    handleChangeSaleType() {
      this.loadData()
    },
  },
}
</script>

<style lang="scss" scoped>
#custom-online {
  display: block;
  margin: 0 0 0 246px;
  ::v-deep .el-radio {
    color: rgb(89, 90, 90);
  }

  ::v-deep .el-form-item__label {
    color: rgb(89, 90, 90);
  }
  ::v-deep .el-form-item::after,
  ::v-deep .el-form-item::before {
    display: inline-block;
    content: inherit;
  }
  ::v-deep .el-form-item__content::after,
  ::v-deep .el-form-item__content::before {
    display: inline-block;
    content: "";
  }

  ::v-deep .el-pagination::after,
  ::v-deep .el-pagination::before {
    display: inline-block;
    content: inherit;
  }
}
#custom-online .tab-body .pro-card {
  border: 1px solid transparent;
  padding: 0;
  margin-top: 0px;
}
#custom-online .tab-body .pro-card .pro-content {
  border: 0;
  border-radius: 5px;
  padding: 0px 8px 8px 8px;
  box-sizing: border-box;
}
#custom-online .tab-body {
  ::v-deep .el-form-item__content {
    line-height: 50px;
  }
  .product-list {
    overflow: hidden;
    ::v-deep .pro-card:first-child {
    }
    ::v-deep .pro-card:last-child {
    }

    .pro-card {
      width: calc(20% - 16px);
      float: left;
      box-sizing: border-box;
      margin: 4px 12px 12px 4px;
      background: #ffffff;
      border: 1px solid transparent;
      border-radius: 5px;
      background: transparent;
      position: relative;
      .pro-card-content-detail {
        padding: 0;
        border: 1px solid #ddd;
        background: #ffffff;
        overflow: hidden;
        border-radius: 17px;
      }
      .detail {
        line-height: 30px;
      }
      .unit {
        font-size: 12px;
      }
      .card-img {
        cursor: pointer;
        overflow: hidden;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }
      .image {
        padding: 16px;
        cursor: pointer;
      }
      .text {
        overflow: hidden;
        font-size: 14px;
      }
      .product-title {
        font-size: 14px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .product-tag {
        line-height: 14px;
        margin: 0 0 10px 0;
        div {
          display: inline-block;
          font-size: 12px;
          padding: 2px 6px;
          background: #409eff;
          border-radius: 5px;
          color: #ffffff;
        }
      }
      .factory {
        border-top: 1px solid #ebeef5;
        margin: 6px 0 0 0;
        padding: 3px 0 0 0;
      }
      .design-num {
        margin: 6px 0 0 0;
        padding: 3px 0 0 0;
        overflow: hidden;
        .num {
          cursor: pointer;
          font-weight: bold;
        }
        .left {
          float: left;
        }
        .right {
          float: right;
        }
        .design-num-link {
          cursor: pointer;
        }
      }
      .price {
        float: left;
        font-size: 18px;

        font-weight: bold;
      }
      .date {
        float: right;
      }
    }
    .pro-card:hover {
      cursor: auto;
      color: #000 !important;
      box-shadow: rgb(0 0 0 / 5%) 2px 6px 10px 5px;
      border: 1px solid #dddddd !important;
      border-radius: 20px;
      .pro-card-content-detail {
        // border: 1px solid transparent;
      }
      .product-type {
        display: block;
      }
      .vip-type {
        display: block;
      }
    }
  }
}
.form-body {
  margin-right: 8px;
  padding-bottom: 6px;
  padding: 10px 0;
}
.form {
  padding: 0 16px;
}

.sku-img-list {
  clear: both;
  width: 223px;
}

.sku-img-list .prev {
  float: left;
  margin-right: 2px;
}
.sku-img-list .next {
  float: right;
}
.sku-img-list .prev,
.tab-body .pro-card .pro-content .sku-img-list .next {
  display: block;
  font-family: "宋体";
  text-align: center;
  width: 10px;
  height: 25px;
  line-height: 25px;
  cursor: pointer;
  text-decoration: none;
}
.sku-img-list .img-content {
  position: relative;
  height: 45px;
  overflow: hidden;
}
.sku-img-list ul {
  position: absolute;
  width: 99999px;
  height: 40px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  list-style-type: none;
}
.sku-img-list ul li {
  float: left;
  width: 25px;
  height: 25px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ebeef5;
  margin-right: 4px;
}
.sku-img-list ul li img {
  width: 25px;
  height: 25px;
}
.sku-img-list ul li img:hover {
}
.price-gradient-box {
  overflow: hidden;
  width: 100%;
  background: #fff;
  z-index: 100;
  transform: translateZ(1000px);
  font-size: 12px;
}
.price-gradient-box .weight-box {
  height: 30px;
  line-height: 30px;
  border: 1px solid #ededed;
  text-align: center;
}
.price-gradient-box .weight-box div:not(:first-child) {
  border-left: 1px solid #ededed;
}
.price-gradient-box > div {
  background: #fff;
}
.price-gradient-box:hover,
.com-pt-img:hover ~ .price-gradient-box {
  bottom: 5px;
  left: 0;
  overflow: hidden;
  z-index: 100;
  transform: translateZ(1000px);
}
.price-gradient-box .swiper-slide {
  text-align: center;
  border: 1px solid #ededed;
  padding: 10px 0;
}
.price-gradient-box .swiper-slide + .swiper-slide {
  border-left: none;
}
.product-swiper-box .next-btn,
.product-swiper-box .per-btn,
.price-gradient-box .next-btn,
.price-gradient-box .per-btn {
  z-index: 2;
  top: 60px;
  padding: 5px;
  width: 20px;
  height: 20px;
  line-height: 0px;
  background: rgba(235, 246, 255, 0.5);
  text-align: center;
}
.w50 {
  width: 50% !important;
}
.flex-x-full {
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.flex-row {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}
.red {
  color: #ff4d3a !important;
}
.c153 {
  color: rgb(153, 153, 153);
}
.filter {
  background: #ffffff;
  border-top: 1px solid rgb(221, 221, 221);
  margin: 4px 0 0 0;
  overflow: hidden;
  padding: 12px 16px 0 16px;
}
.left {
  float: left;
}
.right {
  float: right;
}
.is-select {
  border: 1px solid #f25551 !important;
}
#custom-online .tab-body .card-img:hover {
  // .card-info .info-div {
  //   opacity: 0;
  // }
  // .card-info .btn-div {
  //   opacity: 1;
  // }
}
#custom-online .tab-body .pro-card .card-info {
  height: 138px;
  padding: 2px 16px 8px 16px;
}
.title {
  font-size: 14px;
  border-bottom: 1px solid #cccccc;
  padding: 8px;
}
.left_url_tab
  ::v-deep
  .is-current
  > .el-tree-node__content
  > .el-tree-node__label {
  background: #409eff;
  padding: 0 4px;
  border-radius: 4px;
  color: #ffffff;
}
.left_url_tab ::v-deep .el-tree-node:focus > .el-tree-node__content {
  background-color: inherit;
}
.left_url_tab ::v-deep .el-tree-node {
  padding: 2px 0;
}
.form-label {
  display: inline-block;
  font-size: 13px;
  color: #595a5a;
  width: 80px;
  padding: 0 0 0 32px;
}
.sku-img-list {
  position: absolute;
  display: none;
}
.sku-img-list {
  top: 251px;
  left: 16px;
}
.pro-card-content-detail:hover {
  .sku-img-list {
    display: block;
  }
}
.card_shadow {
  box-shadow: rgb(0 0 0 / 5%) 2px 6px 10px 5px;
  border: 1px solid rgb(228, 228, 228) !important;
}
.prod_drop_con {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
}
.prod_drop_item,
.prod_drop_item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.prod_drop_desc,
.prod_drop_desc {
  display: flex;
  flex-direction: column;
}
.prod_drop_item,
.prod_drop_item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.prod_drop_desc span:nth-child(1),
.prod_drop_desc span:nth-child(1) {
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Semibold, "PingFang SC";
  font-weight: 600;
  color: rgb(153, 153, 153);
  line-height: 20px;
}
.prod_drop_desc span:nth-child(2),
.prod_drop_desc span:nth-child(2) {
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, "PingFang SC";
  font-weight: 400;
  color: rgb(153, 153, 153);
  line-height: 20px;
}

.detail .price:hover {
  .el-icon-arrow-down {
    display: none;
  }
  .el-icon-arrow-up {
    display: inline-block !important;
  }
}
.order-area {
  margin: 2px 0 0 0;
}
.order-area ::v-deep {
  .el-table__body-wrapper {
    display: none;
  }
  .el-table td,
  .el-table th {
    padding: 0;
  }
}
.product-type {
  position: absolute;
  left: 34px;
  top: 14px;
  border-color: #ff9000;
  background-color: #ff9000;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
  display: none;
}

.vip-type {
  position: absolute;
  right: 17px;
  top: 14px;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
  display: none;
  img {
    width: 39px;
  }
}

.evenflow_scale:hover {
  transform: scale(1.05, 1.05);
}
.evenflow_scale {
  transition: all 0.6s ease;
}
</style>
